import { FC } from 'react'
import { DrawingType } from '../types/project'

interface TabBarProps {
  currentTab: DrawingType
  onTabChange: (tab: DrawingType) => void
}

const tabs: { id: DrawingType; label: string }[] = [
  { id: 'layout', label: '設置場所見取図' },
  { id: 'plan', label: '平面図' },
  { id: 'wiring', label: '配線ルート図' },
  { id: 'diagram', label: '電気系統図' },
]

const TabBar: FC<TabBarProps> = ({ currentTab, onTabChange }) => {
  return (
    <div className="bg-white border-b border-gray-200 px-4 flex gap-1">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`
            px-6 py-3 font-medium transition-colors relative
            ${
              currentTab === tab.id
                ? 'text-primary-600 border-b-2 border-primary-600'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default TabBar
